<template>
	<div>
		<egranty-section-divider
			text="Udostępnione projekty"
		/>
		<div v-for="projectBasicData in allowedProjectsData" :key="projectBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{projectBasicData.projectCode}} &emsp; {{projectBasicData.title}}</h3>
					<egranty-icon-button
						label="Podgląd"
						icon="assignment"
						@click="() => viewProject(projectBasicData)"
					/>
				</v-layout>
			</v-card>
		</div>
	</div>
</template>

<script>
	import {Project} from "../../../api/generated/Project";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AllowedProjectsView",
		components: {EgrantyIconButton, EgrantySectionDivider},
		data () {
			return {
				allowedProjectsData: []
			};
		},

		methods: {
			viewProject (projectBasicData) {
				this.$router.openInNewTab("/view/project/" + projectBasicData.id);
			}
		},

		mounted () {
			Project.getAllowedBasicData(this, response => this.allowedProjectsData = response);
		}
	};
</script>

<style scoped>

</style>